import { Treatment } from '@enums/treatment';

import { ConsultationRequestPartner } from './consultation-request-partner';
import { ConsultationRequestPharmacy } from './consultation-request-pharmacy';

export class ConsultationRequestAdditionalInfo {
  public partner?: ConsultationRequestPartner;
  public pharmacy?: ConsultationRequestPharmacy;
  public height: { feet: number; inches: number };
  public weight: number;

  public constructor(partnerFormValues: any, treatment: Treatment, personalFormValues: any) {
    if ([Treatment.Partner, Treatment.SelfAndPartner].includes(treatment)) {
      this.partner = new ConsultationRequestPartner(partnerFormValues);
    }
    this.height = {
      feet: personalFormValues.height_feet,
      inches: personalFormValues.height_inches,
    };
    this.weight = personalFormValues.weight;
  }
}
